import React from 'react';

const PlayIcon = () => {
  return <div className="play-icon">
    <svg viewBox="0 0 20 20" preserveAspectRatio="xMidYMid" focusable="false" aria-labelledby="play-icon-title" role="img"><title id="play-icon-title">Play</title><polygon className="fill" points="1,0 20,10 1,20"></polygon></svg>
  </div>
}

export default PlayIcon;